module.exports = __webpack_public_path__ + "components/Game/Steps/Intruder/IntruderQuestionImage-2.6853fc1be862f290953824b2227015ac.jpg";